import { containersApi, containersApiBlob, containersApiFormData } from './api';

const baseUri = 'files';

export const documentTypes = { pdf: 'pdf', html: 'html' };

export const FileAPI = {
  getFile: (path) => containersApiBlob.get(`${baseUri}?path=${path}`),
  getFiles: (path) => containersApi.get(`${baseUri}/list?path=${path}`),
  deleteFile: (filePath) => containersApi.delete(`${baseUri}?path=${filePath}`),
  uploadFile: (file) => containersApi.post(`${baseUri}`, file),
  cacheDocumentModel: (documentModel) =>
    containersApi.post(`${baseUri}/cache`, documentModel),
  generateDocumentUrl: ({
    accessKey,
    type = 'pdf',
    templatePath,
    fileName,
    retrievalType = `url`,
  }) => {
    if (retrievalType === 'blob') {
      return containersApiBlob.get(
        `${process.env.NEXT_PUBLIC_CONTAINERS_API}/${baseUri}/cache/${
          accessKey || ''
        }?type=${type || ''}&templatePath=${templatePath || ''}&fileName=${
          fileName || ''
        }`
      );
    } else if (retrievalType === 'url') {
      return `${process.env.NEXT_PUBLIC_CONTAINERS_API}/${baseUri}/cache/${
        accessKey || ''
      }?type=${type || ''}&templatePath=${templatePath || ''}&fileName=${
        fileName || ''
      }`;
    }
  },
  addDocumentLinksFile: (formData) =>
    containersApiFormData.post(`${baseUri}/documentLinksFile`, formData),
  deleteDocumentLinksFile: (fileName) =>
    containersApi.delete(`${baseUri}/documentLinksFile?fileName=${fileName}`),
  downloadTaxExemptionCertificate: (certificateId) =>
    containersApiBlob.get(
      `${baseUri}/taxExemptionCertificates/${certificateId}`
    ),
};
